import { Component } from '@angular/core';

@Component({
    selector: 'app-notfound',
    imports: [],
    templateUrl: './notfound.component.html',
    styleUrl: './notfound.component.scss'
})
export class NotFoundComponent {

}
